export const GET_LIST_WAITING_CENSORSHIP = 'GET_LIST_WAITING_CENSORSHIP'
export const GET_LIST_WAITING_CENSORSHIP_ERR = 'GET_LIST_WAITING_CENSORSHIP_ERR'

export const RESET_LIST_WAITING_CENSORSHIP = 'RESET_LIST_WAITING_CENSORSHIP'

export const UPDATE_WAITING_CONDFILTERS = 'UPDATE_WAITING_CONDFILTERS'
export const RESET_WAITING_CONDFILTERS = 'RESET_WAITING_CONDFILTERS'